import axios from "axios";

const http = axios.create({
  baseURL: "https://aerosafedemo.aeontechhub.com/Aero/",
});

const verifyEmail = (data) => {
  return http.post(`api/emailverify`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const verifyOtp = (data) => {
  return http.post(`api/verificationstack`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getOrderId = (data) => {
  return http.post(`api/getorderid`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const verifySignature = (data) => {
  return http.post(`api/verifypay`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const PaymentService = {
  verifyEmail,
  verifyOtp,
  getOrderId,
  verifySignature,
};

export default PaymentService;
